// extracted by mini-css-extract-plugin
export default {"image":"ResponsiveImage___responsiveImage-module__image___6m4MF","picture":"ResponsiveImage___responsiveImage-module__picture___RJyjD"};